import {isElementInViewport} from '@elements/viewport-utils'
import {initAjaxFormMap, apiLoaded} from "@elements/ajax-form-map/ajax-form-google";
import {addMarker, setActiveMarkerStyle, setActiveClusterStyle, setDefaultClusterStyle, setDefaultMarkerStyle} from "@elements/google-map";

let ajaxFormMapObj;

export function initInScope($scope) {
    let $maps = $scope.find('.js-ajax-form-map__map');
    if ($maps && $maps.length) {
        $maps.each(function (index, element) {
            let $container = $(element).closest('.js-ajax-form-map');
            let $mapCanvas = $(element).find('.js-ajax-form-map__map__canvas');


            apiLoaded().then(function () {
                const poiStyles = {
                    default: {
                        default: {
                            url: '/static/build/img/map/poi.svg',
                            size: new google.maps.Size(30, 38),
                            scaledSize: new google.maps.Size(30, 38),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(15, 38)
                        },
                        active: {
                            url: '/static/build/img/map/poi-active.svg',
                            size: new google.maps.Size(30, 38),
                            scaledSize: new google.maps.Size(30, 38),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(15, 38)
                        }
                    }
                };

                let clusteringOptions = {
                    default: {
                        styles: [{
                            height: 37,
                            url: "/static/build/img/map/cluster.svg",
                            width: 30,
                            anchor: [-7,-7],
                            textSize: 14,
                            textColor: "#504f50",
                        }]
                    },
                    active: {
                        styles: [{
                            height: 37,
                            url: "/static/build/img/map/cluster.svg",
                            width: 30,
                            anchor: [-7,-7],
                            textSize: 14,
                            textColor: "#504f50",
                        }]
                    }
                };

                let options = {
                    mapTypeControl: false,
                    streetViewControl: false,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.TOP_LEFT,
                    },
                    fullscreenControl: false,
                    styles: [
                        {
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                }
                            ]
                        },
                        {
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#616161"
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative.land_parcel",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#bdbdbd"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#eeeeee"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#757575"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#e5e5e5"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#9e9e9e"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#757575"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#dadada"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#616161"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#9e9e9e"
                                }
                            ]
                        },
                        {
                            "featureType": "transit.line",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#e5e5e5"
                                }
                            ]
                        },
                        {
                            "featureType": "transit.station",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#eeeeee"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#c9c9c9"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#9e9e9e"
                                }
                            ]
                        }
                    ]

                };

                //init ajax form map
                ajaxFormMapObj = initAjaxFormMap($scope.find('.js-ajax-form-map'), undefined, {
                    element: $mapCanvas[0],
                    mapOptions: options,
                    poiStyles,
                    clustering: false,
                    clusteringOptions,
                    onActivateMarker: (marker, mapObj) => onActivateMarker($container, marker, mapObj),
                    onDeactivateMarker: (marker, mapObj) => onDeactivateMarker($container, marker, mapObj)
                });

                initMapItems(ajaxFormMapObj.mapObj, $container);
            });
        });
    }

    let $ajaxForm = $scope.find('.js-ajax-form-map');

    let geocoder;

    apiLoaded().then(function () {
        geocoder = new google.maps.Geocoder();
        zoomToLocation(geocoder);
    });


    $ajaxForm.on('success.ajax-form', function() {
        zoomToLocation(geocoder);
    });

    $scope.find('.js-ajax-form-map__submit-btn').on('click', function (e) {
        geocodeLocation(geocoder, $scope);
    });
}


function zoomToLocation(geocoder) {
    let location = $('.js-location-input').val();
    if(location){
        geocoder.geocode({
            'address': location,
            componentRestrictions: {
                country: 'AT'
            }
        }, function(results, status) {
            if (status === 'OK') {
                ajaxFormMapObj.mapObj.map.setCenter(results[0].geometry.location);
                ajaxFormMapObj.mapObj.map.setZoom(10);
            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });

    }
}

export function zoomInMap(lat,lng){
    ajaxFormMapObj.mapObj.map.setCenter(new google.maps.LatLng(lat, lng));
    ajaxFormMapObj.mapObj.map.setZoom(10);
}

function geocodeLocation(geocoder, $scope) {
    let location = $scope.find('.js-location-input').val();
    if(location){
        geocoder.geocode({
            'address': location,
            componentRestrictions: {
                country: 'AT'
            }
        }, function(results, status) {
            if (status === 'OK') {
                let $locationInput = $('.js-location-input'),
                    $targetLat = $($locationInput.data('target-lat')),
                    $targetLng = $($locationInput.data('target-lng'));

                $targetLat.val(results[0].geometry.location.lat());
                $targetLng.val(results[0].geometry.location.lng());

                $('.js-ajax-form-map__form').trigger('submit');
            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });

    }
}

function onActivateMarker($container, marker, mapObj) {
    if (marker.dataId) {
        let $item = $container.find(`.js-ajax-form-map__item[data-id="${marker.dataId}"]`);
        $item.addClass('is-active');

        if ($item && $item.length ) {
            let $storeTeaserListOverflow = $('.store-teaser-list-overflow');

            $storeTeaserListOverflow.stop().animate({
                scrollTop: $storeTeaserListOverflow.scrollTop() + $item.position().top
            }, 200);
        }
    }
}

function onDeactivateMarker($container, marker, mapObj) {
    // closeInfoBoxByMarker(marker, mapObj);
    if (marker.dataId) {
        $container.find(`.js-ajax-form-map__item[data-id="${marker.dataId}"]`).removeClass('is-active');
        // if ($container.find(`.js-ajax-form-map__item[data-id="${marker.dataId}"]`).find('.collapse')){
        //     $container.find(`.js-ajax-form-map__item[data-id="${marker.dataId}"]`).find('.collapse').collapse('hide');
        // }
    }
}

function initMapItems(mapObj, $container) {
    $container.find('.js-ajax-form-map__item').each(function () {
        let $item = $(this);

        $item.on('mouseenter', function () {
            let id = $(this).data('id');
            let activeMarker = mapObj.marker.filter(marker =>
                !!marker.dataId && marker.dataId.toString() === id.toString())[0];

            if (activeMarker) {
                setActiveMarkerStyle(activeMarker, mapObj);


                if (mapObj.clusteringPromise) {
                    mapObj.clusteringPromise.then((markerCluster) => {
                        let clusters = markerCluster.getClusters();

                        clusters.forEach(cluster => setDefaultClusterStyle(cluster, mapObj));

                        let activeCluster = clusters.find(cluster =>
                            cluster.getMarkers().find(marker => marker === activeMarker)
                        );

                        setActiveClusterStyle(activeCluster, mapObj);
                    });
                }
            }
        }).on('mouseleave', function () {
            let id = $(this).data('id');
            let activeMarker = mapObj.marker.filter(marker =>
                !!marker.dataId && marker.dataId.toString() === id.toString())[0];

            if (activeMarker) {
                setDefaultMarkerStyle(activeMarker, mapObj);
            }

            if (mapObj.clusteringPromise) {
                mapObj.clusteringPromise.then((markerCluster) => {
                    markerCluster.getClusters().forEach(
                        cluster => setDefaultClusterStyle(cluster, mapObj)
                    );
                });
            }
        });
    });
}

